export default {
  workbench: {
    attendance: "出勤相關",
    punch: "打卡",
    makeupPunch: "補卡",
    leave: "請假",
    overtime: "加班",
    hrManagement: "人事管理",
    recruitment: "招聘需求申請",
    becomeRegular: "轉正申請",
    transfer: "調崗申請",
    salaryAdjustment: "薪資調整申請",
    financeManagement: "財務管理",
    payment: "付款申請",
    reimbursement: "費用報銷",
    purchase: "採購申請",
    pettyCash: "備用金申請",
    noPermission: "暫無權限，如需使用此功能，請聯繫管理員開通"
  }
}
